export type VisemeFrame = {
  id: number;
  /** Azure TTS units: 100-nanosecond ticks from start */
  offset: number;
};

/**
 * Schedule mouth-shape swaps to match Azure TTS viseme timeline (extension learning.js).
 * Delay between frames = (offset - prevOffset) / 10000 ms.
 */
export function scheduleVisemes(
  visemes: VisemeFrame[],
  onId: (id: number) => void,
): () => void {
  const queue = visemes.map((v) => ({ ...v }));
  const timers: number[] = [];
  let prevOffset = 0;
  let cancelled = false;

  const step = () => {
    if (cancelled || queue.length === 0) return;
    const item = queue.shift();
    if (!item) return;
    onId(item.id);
    prevOffset = item.offset;
    if (queue.length === 0) return;
    const next = queue[0]!;
    const delay = Math.max(0, (next.offset - prevOffset) / 10000);
    timers.push(window.setTimeout(step, delay));
  };

  if (queue.length > 0) {
    const first = queue[0]!;
    const delay = Math.max(0, (first.offset - prevOffset) / 10000);
    timers.push(window.setTimeout(step, delay));
  }

  return () => {
    cancelled = true;
    for (const t of timers) window.clearTimeout(t);
  };
}

export function visemeImageUrl(id: number): string {
  const safe = Number.isFinite(id) ? Math.max(0, Math.min(21, Math.round(id))) : 0;
  return `/viseme/viseme-id-${safe}.jpg`;
}
